import { useEffect, useState, useCallback } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import AddDrinkForm from "../components/AddDrinkForm";
import MyStatsModal from "../components/MyStatsModal";
import { getAlcools, getVerres, getDashboard, deleteVerre } from "../services/drinkService";

export default function Dashboard() {
  const [alcools, setAlcools] = useState([]);
  const [verres, setVerres] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showMyStats, setShowMyStats] = useState(false);

  const loadAll = useCallback(async () => {
    const [a, v, s] = await Promise.all([getAlcools(), getVerres(), getDashboard()]);
    setAlcools(a);
    setVerres(v);
    setStats(s);
    setLoading(false);
  }, []);

  useEffect(() => {
    loadAll();
  }, [loadAll]);

  const handleDelete = async (id) => {
    await deleteVerre(id);
    loadAll();
  };

  if (loading) return <p className="center-loading">Chargement...</p>;

  const maxNb = stats.repartition[0]?.nb || 1;

  return (
    <>
      <Navbar />
      <main className="page">
        <h1>Ton tableau de bord</h1>

        <section className="stats-grid">
          <div
            className="card stat-card stat-card-clickable"
            onClick={() => setShowMyStats(true)}
          >
            <span className="stat-number">{stats.total_verres}</span>
            <span className="stat-label">Verres au total</span>
          </div>
          <div className="card stat-card">
            <span className="stat-number">
              {stats.alcool_favori ? stats.alcool_favori.nom : "—"}
            </span>
            <span className="stat-label">
              Alcool favori{" "}
              {stats.alcool_favori && `(${stats.alcool_favori.nb} verres)`}
            </span>
          </div>
        </section>

        <section className="grid-2">
          <AddDrinkForm alcools={alcools} onAdded={loadAll} />

          <div className="card">
            <h3>Répartition par alcool</h3>
            {stats.repartition.length === 0 && (
              <p className="muted">Pas encore de verre enregistré.</p>
            )}
            <ul className="bar-list">
              {stats.repartition.map((r) => (
                <li key={r.id}>
                  <div className="bar-row">
                    <span>{r.nom}</span>
                    <span>{r.nb}</span>
                  </div>
                  <div className="bar-track">
                    <div
                      className="bar-fill"
                      style={{ width: `${(r.nb / maxNb) * 100}%` }}
                    />
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </section>

        <section className="card">
          <h3>Historique</h3>
          {verres.length === 0 && <p className="muted">Aucun verre pour l'instant.</p>}
          <ul className="history-list history-list-scroll">
            {verres.map((v) => (
              <li key={v.id}>
                <span className="history-alcool">{v.alcool_nom}</span>
                <span className="history-date">
                  {new Date(v.date_conso).toLocaleString("fr-FR")}
                </span>
                <button className="btn-ghost small" onClick={() => handleDelete(v.id)}>
                  Supprimer
                </button>
              </li>
            ))}
          </ul>
        </section>
      </main>
      <Footer />

      {showMyStats && <MyStatsModal onClose={() => setShowMyStats(false)} />}
    </>
  );
}